import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle, X, ShoppingCart } from 'lucide-react';
interface ToastProps {
  isVisible: boolean;
  productName: string;
  onClose: () => void;
  onViewCart: () => void;
}
export function Toast({
  isVisible,
  productName,
  onClose,
  onViewCart
}: ToastProps) {
  useEffect(() => {
    if (isVisible) {
      const timer = setTimeout(() => {
        onClose();
      }, 5000); // Auto-close after 5 seconds
      return () => clearTimeout(timer);
    }
  }, [isVisible, onClose]);
  return <AnimatePresence data-id="element-992">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      scale: 0.95
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.95
    }} className="fixed bottom-6 right-6 z-50 max-w-md" data-id="element-993">
          <div className="bg-white rounded-2xl shadow-2xl border border-rose-100 p-6 flex items-start gap-4" data-id="element-994">
            <div className="flex-shrink-0" data-id="element-995">
              <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center" data-id="element-996">
                <CheckCircle className="w-6 h-6 text-green-600" data-id="element-997" />
              </div>
            </div>

            <div className="flex-1 min-w-0" data-id="element-998">
              <h3 className="font-semibold text-gray-900 mb-1" data-id="element-999">
                Added to cart!
              </h3>
              <p className="text-sm text-gray-600 mb-4 line-clamp-2" data-id="element-1000">
                <span className="font-medium" data-id="element-1001">{productName}</span> has been
                added to your cart
              </p>

              <div className="flex gap-3" data-id="element-1002">
                <button onClick={onViewCart} className="flex items-center gap-2 px-4 py-2 bg-rose-500 text-white rounded-lg hover:bg-rose-600 transition-colors text-sm font-medium" data-id="element-1003">
                  <ShoppingCart className="w-4 h-4" data-id="element-1004" />
                  View Cart
                </button>
                <button onClick={onClose} className="px-4 py-2 text-gray-600 hover:text-gray-900 transition-colors text-sm font-medium" data-id="element-1005">
                  Continue Shopping
                </button>
              </div>
            </div>

            <button onClick={onClose} className="flex-shrink-0 p-1 text-gray-400 hover:text-gray-600 transition-colors" data-id="element-1006">
              <X className="w-5 h-5" data-id="element-1007" />
            </button>
          </div>
        </motion.div>}
    </AnimatePresence>;
}